import { ReactElement } from "react"

import CreateHpDeviceForm from "../../../../components/devices/lct/hp/createHpDeviceForm"
import PublishHpDeviceProvider from "../../../../components/devices/lct/hp/providers/publishHpDeviceProvider"

/** Component to publish a new hp device */
const PublishHpDevice = (): ReactElement => (
    <PublishHpDeviceProvider>
        <CreateHpDeviceForm />
    </PublishHpDeviceProvider>
)

export default PublishHpDevice
